import { DEFAULT_COLOR_GRAY, DEFAULT_MARKDOWN_PLACEHOLDER } from '../constants'
import { baseSchemaProperties } from '../base-schema-properties'
import { textAlignSchemaField } from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Title',
  description: 'Block with markdown without background',
  type: 'object',
  required: ['text'],
  properties: {
    ...baseSchemaProperties,
    text: {
      title: 'Text',
      type: 'string',
      'ui:options': {
        placeholder: DEFAULT_MARKDOWN_PLACEHOLDER,
        type: 'textarea',
        rows: 3,
      },
    },
    textAlign: textAlignSchemaField,
    textColor: {
      title: 'Text Color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
    },
  },
}
